export default {
  /* 主要ボタン*/
  button_save: '・保存する',
  contact_btn_send: '・送信',
  upload: '・アップロード',
  cancel: '・キャンセル',
  saved: '・保存しました',

  /* ポップアップ表示など*/
  confirm_delete_image: '・写真を削除しますか？',
  favorite_success: '・お気に入りに登録しました',
  favorite_cancel: '・お気に入りを解除しました',
  report_success: '・通告を報告しました',
  ask_report: '・このユーザーを通告しますか？',
  ask_block: '・このユーザーをブロックしますか',

  /* フォーム内テキスト*/
  contact_label_fullname: '・お名前（フルネーム）',
  contact_label_email: '・メールアドレス（正確にご入力下さい）',
  contact_label_phone: '・電話番号',
  contact_label_title: '・問い合わせ内容',
  contact_label_content: '・本文',

  /* その他*/
  confirm_send_contact: '・確認し送信',
  entry_job: '・お仕事に応募しました（Member)',

  payment_success: '決済が成功しました',
  payment_fail: '決済に失敗しました',
};
